import { render, staticRenderFns } from "./timindexFour.vue?vue&type=template&id=d6ed7c62&scoped=true"
import script from "./timindexFour.vue?vue&type=script&lang=js"
export * from "./timindexFour.vue?vue&type=script&lang=js"
import style0 from "./timindexFour.vue?vue&type=style&index=0&id=d6ed7c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ed7c62",
  null
  
)

export default component.exports